var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"purchases-view mb-3"},[_c('page-title',{attrs:{"title":_vm.translation('my_products_administration'),"icon":"gifts"}}),_c('product-filters-bar'),_c('products-list'),_c('product-transfer-modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }